
import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { BiMenu } from "react-icons/bi";


export default function Navbar() {
  const [open, setOpen] = useState(false);


  const closeMenu = () => setOpen(false);

  return (
    <nav className="sticky top-0 z-50 bg-teal-500/95 backdrop-blur supports-[backdrop-filter]:bg-teal-500/80 shadow-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Linha principal */}
        <div className="flex h-14 sm:h-16 items-center justify-between">
          {/* Brand */}
          <Link
            to="/"
            className="inline-flex items-center gap-2 group"
            onClick={closeMenu}
            aria-label="Ir para a página inicial"
          >
            <div className="leading-tight">
              <span className="block font-bold text-lg sm:text-xl text-letras group-hover:opacity-90">
                WebAgendamento
              </span>
              <span className="block text-xs sm:text-sm text-green-dark -mt-0.5">
                Mosqueiro
              </span>
            </div>
          </Link>

          {/* Menu desktop */}
          <div className="hidden lg:flex items-center gap-2">
            <Link
              to="/contato"
              className="px-4 py-2 rounded-md font-abc text-base  text-outra font-bold hover:text-outra focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 transition"
            >
              Nossos Contatos
            </Link>
            <Link
              to="/ajuda"
              className="px-4 py-2 rounded-md font-abc text-base text-outra font-bold hover:text-letras focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 transition"
            >
              Dúvidas
            </Link>
          </div>

          {/* Botão mobile */}
          <button
            type="button"
            className="lg:hidden inline-flex items-center justify-center rounded-md p-2 text-letras2 hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 transition"
            aria-controls="mobile-menu"
            aria-expanded={open}
            aria-label="Abrir menu"
            onClick={() => setOpen((v) => !v)}
          >
            <BiMenu className="h-6 w-6" />
          </button>
        </div>

        {/* Menu mobile */}
        <div
          id="mobile-menu"
          className={`${open ? "block" : "hidden"} lg:hidden border-t border-white/10`}
        >
          <div className="py-2 space-y-1">
            <Link
              to="/contato"
              onClick={closeMenu}
              className="block px-3 py-2 rounded-md font-abc text-base text-letras font-bold hover:text-hoverspt hover:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 transition"
            >
              Nossos Contatos
            </Link>
            <Link
              to="/ajuda"
              onClick={closeMenu}
              className="block px-3 py-2 rounded-md font-abc text-base text-letras font-bold hover:text-hoverspt hover:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 transition"
            >
              Dúvidas
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
